/**
 * @generated SignedSource<<720f9f08fff457a87584437245f28898>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type SearchLinkedResultCategory = "child" | "mentionedBy" | "mentions" | "similar" | "%future added value";
export type SearchResultType = "ask" | "attachment" | "blogpost" | "board" | "code" | "comment" | "component" | "dashboard" | "database" | "document" | "embed" | "filter" | "focus_area" | "focus_area_status_update" | "folder" | "goal" | "goal_update" | "issue" | "learning" | "message" | "object" | "organization" | "organization_status_update" | "page" | "plan" | "playlist" | "position" | "presentation" | "project" | "project_update" | "question" | "repository" | "risk" | "schema" | "slide" | "space" | "spreadsheet" | "tag" | "type" | "unrecognised" | "video" | "whiteboard" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchJiraIssue_AtlassianSearchPage$data = {
  readonly __typename: "SearchResultJiraIssue";
  readonly description: string;
  readonly iconUrl: string | null;
  readonly id: string;
  readonly issue: {
    readonly assignee?: {
      readonly name: string;
      readonly picture: AGG$URL;
    } | null;
    readonly assigneeField?: {
      readonly user: {
        readonly name: string;
        readonly picture: AGG$URL;
      } | null;
    } | null;
    readonly fastLabels?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly name: string | null;
        } | null;
      } | null> | null;
    } | null;
    readonly fastPriority?: {
      readonly iconUrl: AGG$URL | null;
      readonly name: string | null;
    } | null;
    readonly fieldsById?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __typename: string;
          readonly name: string;
          readonly project?: {
            readonly id: string;
            readonly name: string;
          } | null;
        } | null;
      } | null> | null;
    } | null;
    readonly issueType?: {
      readonly avatar: {
        readonly medium: string | null;
      } | null;
      readonly name: string;
    } | null;
    readonly issueTypeAvatarUrl?: AGG$URL | null;
    readonly issueTypeField?: {
      readonly issueType: {
        readonly name: string;
      } | null;
    } | null;
    readonly key: string;
    readonly labelsField?: {
      readonly selectedLabelsConnection: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly name: string | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
    readonly priorityField?: {
      readonly priority: {
        readonly iconUrl: AGG$URL | null;
        readonly name: string | null;
      } | null;
    } | null;
    readonly project?: {
      readonly id: string;
      readonly name: string;
    } | null;
    readonly webUrl: AGG$URL | null;
  } | null;
  readonly lastModifiedDate: string | null;
  readonly linkedResults: ReadonlyArray<{
    readonly category: SearchLinkedResultCategory;
    readonly connectorType: string | null;
    readonly description: string;
    readonly id: string;
    readonly integrationId: string | null;
    readonly lastModifiedDate: string | null;
    readonly providerId: string | null;
    readonly subtype: string | null;
    readonly title: string;
    readonly type: SearchResultType;
    readonly url: string;
  }> | null;
  readonly title: string;
  readonly type: SearchResultType;
  readonly url: string;
  readonly " $fragmentType": "searchJiraIssue_AtlassianSearchPage";
};
export type searchJiraIssue_AtlassianSearchPage$key = {
  readonly " $data"?: searchJiraIssue_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchJiraIssue_AtlassianSearchPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "title"
},
v2 = {
  "kind": "ScalarField",
  "name": "type"
},
v3 = {
  "kind": "ScalarField",
  "name": "description"
},
v4 = {
  "kind": "ScalarField",
  "name": "url"
},
v5 = {
  "kind": "ScalarField",
  "name": "lastModifiedDate"
},
v6 = {
  "kind": "ScalarField",
  "name": "iconUrl"
},
v7 = {
  "kind": "ScalarField",
  "name": "name"
},
v8 = [
  (v7/*: any*/)
],
v9 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v10 = {
  "concreteType": "JiraProject",
  "kind": "LinkedField",
  "name": "project",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    (v7/*: any*/)
  ]
},
v11 = [
  (v7/*: any*/),
  {
    "kind": "ScalarField",
    "name": "picture"
  }
],
v12 = [
  (v6/*: any*/),
  (v7/*: any*/)
],
v13 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 5
  }
],
v14 = [
  {
    "concreteType": "JiraLabelEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "JiraLabel",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": (v8/*: any*/)
      }
    ]
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeFastJiraHydration"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeJiraLiteModeFields"
    }
  ],
  "kind": "Fragment",
  "name": "searchJiraIssue_AtlassianSearchPage",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/),
    (v4/*: any*/),
    (v5/*: any*/),
    (v6/*: any*/),
    {
      "concreteType": "JiraIssue",
      "kind": "LinkedField",
      "name": "issue",
      "plural": false,
      "selections": [
        {
          "condition": "includeFastJiraHydration",
          "kind": "Condition",
          "passingValue": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "issueTypeAvatarUrl"
            },
            {
              "concreteType": "JiraIssueTypeField",
              "kind": "LinkedField",
              "name": "issueTypeField",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraIssueType",
                  "kind": "LinkedField",
                  "name": "issueType",
                  "plural": false,
                  "selections": (v8/*: any*/)
                }
              ]
            },
            {
              "args": [
                {
                  "kind": "Literal",
                  "name": "ids",
                  "value": [
                    "project"
                  ]
                }
              ],
              "concreteType": "JiraIssueFieldConnection",
              "kind": "LinkedField",
              "name": "fieldsById",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraIssueFieldEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v9/*: any*/),
                        (v7/*: any*/),
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v10/*: any*/)
                          ],
                          "type": "JiraProjectField"
                        }
                      ]
                    }
                  ]
                }
              ],
              "storageKey": "fieldsById(ids:[\"project\"])"
            },
            {
              "concreteType": "JiraSingleSelectUserPickerField",
              "kind": "LinkedField",
              "name": "assigneeField",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "name": "user",
                  "plural": false,
                  "selections": (v11/*: any*/)
                }
              ]
            }
          ]
        },
        {
          "kind": "ScalarField",
          "name": "webUrl"
        },
        {
          "kind": "ScalarField",
          "name": "key"
        },
        {
          "condition": "includeFastJiraHydration",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "concreteType": "JiraIssueType",
              "kind": "LinkedField",
              "name": "issueType",
              "plural": false,
              "selections": [
                (v7/*: any*/),
                {
                  "concreteType": "JiraAvatar",
                  "kind": "LinkedField",
                  "name": "avatar",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "medium"
                    }
                  ]
                }
              ]
            },
            (v10/*: any*/),
            {
              "kind": "LinkedField",
              "name": "assignee",
              "plural": false,
              "selections": (v11/*: any*/)
            },
            {
              "condition": "includeJiraLiteModeFields",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "alias": "fastPriority",
                  "concreteType": "JiraPriority",
                  "kind": "LinkedField",
                  "name": "priority",
                  "plural": false,
                  "selections": (v12/*: any*/)
                },
                {
                  "alias": "fastLabels",
                  "args": (v13/*: any*/),
                  "concreteType": "JiraLabelConnection",
                  "kind": "LinkedField",
                  "name": "labels",
                  "plural": false,
                  "selections": (v14/*: any*/),
                  "storageKey": "labels(first:5)"
                }
              ]
            }
          ]
        },
        {
          "condition": "includeJiraLiteModeFields",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "condition": "includeFastJiraHydration",
              "kind": "Condition",
              "passingValue": false,
              "selections": [
                {
                  "concreteType": "JiraPriorityField",
                  "kind": "LinkedField",
                  "name": "priorityField",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "JiraPriority",
                      "kind": "LinkedField",
                      "name": "priority",
                      "plural": false,
                      "selections": (v12/*: any*/)
                    }
                  ]
                },
                {
                  "concreteType": "JiraLabelsField",
                  "kind": "LinkedField",
                  "name": "labelsField",
                  "plural": false,
                  "selections": [
                    {
                      "args": (v13/*: any*/),
                      "concreteType": "JiraLabelConnection",
                      "kind": "LinkedField",
                      "name": "selectedLabelsConnection",
                      "plural": false,
                      "selections": (v14/*: any*/),
                      "storageKey": "selectedLabelsConnection(first:5)"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    (v9/*: any*/),
    {
      "concreteType": "SearchLinkedResult",
      "kind": "LinkedField",
      "name": "linkedResults",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v4/*: any*/),
        (v2/*: any*/),
        (v3/*: any*/),
        (v5/*: any*/),
        {
          "kind": "ScalarField",
          "name": "category"
        },
        {
          "kind": "ScalarField",
          "name": "subtype"
        },
        {
          "kind": "ScalarField",
          "name": "integrationId"
        },
        {
          "kind": "ScalarField",
          "name": "providerId"
        },
        {
          "kind": "ScalarField",
          "name": "connectorType"
        }
      ]
    }
  ],
  "type": "SearchResultJiraIssue"
};
})();

(node as any).hash = "1e0d9132401d35fddac808d2705532f3";

export default node;
